/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React from "react"
import { Checkbox } from "../../atoms/Checkbox"
import { TextLink } from "../../atoms/links/TextLink"
import { Body, Container, Stack } from "@carrotfertility/carotene"
import { useTrackView } from "../../../../utils/heap"
import { FormattedMessage } from "react-intl"
import { RegistrationFlowLayout } from "./RegistrationLayouts"
import { BodySmall } from "components/views/atoms/Bodies"
import { RegistrationButtonFooter, SkipButton, ContinueButton } from "./RegistrationButtons"

interface EmailOptInProps {
  isSubmitting: boolean
  emailOptIn: boolean
  setEmailOptIn: (newValue: boolean) => void
  onBack: () => void
  onComplete: () => void
}

export default function EmailOptIn({
  isSubmitting,
  emailOptIn,
  setEmailOptIn,
  onBack,
  onComplete
}: EmailOptInProps): JSX.Element {
  useTrackView("EmailOptInRegFlow", "Email opt in screen")

  return (
    <RegistrationFlowLayout
      header={<FormattedMessage defaultMessage="Stay updated" />}
      imageName="illo-paper-airplane"
      description={
        <>
          <Container stack="medium">
            <Body color="black-80">
              <FormattedMessage
                defaultMessage="We’ll share occasional updates about your Carrot benefit, such as new features and partnerships, as well as
           member-only expert resources."
              />
            </Body>
          </Container>
          <label>
            <Stack direction="row" spacing="10px">
              <Checkbox
                id="email-opt-in-checkbox"
                checked={emailOptIn}
                onChange={(e) => setEmailOptIn(e.target.checked)}
              />
              <Stack spacing="small" width={["356px", null, "456px"]}>
                <Body>
                  <FormattedMessage defaultMessage="Yes, keep me updated." />
                </Body>
                <BodySmall>
                  <FormattedMessage
                    defaultMessage="We will protect your data and keep your information confidential in accordance with our <link>Privacy Notice</link>. You can unsubscribe at any time in your account settings."
                    values={{
                      link: (linkText) => (
                        <TextLink
                          underlineColor="black-80"
                          target="_blank"
                          href="https://www.get-carrot.com/privacy-notice"
                        >
                          {linkText}
                        </TextLink>
                      )
                    }}
                  />
                </BodySmall>
              </Stack>
            </Stack>
          </label>
        </>
      }
      interactiveElements={
        <RegistrationButtonFooter
          onBack={onBack}
          skipButton={
            <SkipButton onClick={onComplete}>
              <FormattedMessage defaultMessage="Skip" />
            </SkipButton>
          }
          continueButton={
            <ContinueButton onClick={onComplete} disabled={isSubmitting}>
              <FormattedMessage defaultMessage="Continue" />
            </ContinueButton>
          }
        />
      }
    />
  )
}
